import { hasFeature, FEATURES, type FeatureKey, type Plan } from "@workspace/plans";
import { useOrg } from "./orgContext";

export interface FeatureState {
  enabled: boolean;
  currentPlan: string;
  normalizedPlan: Plan;
  requiredPlan: Plan;
  feature: FeatureKey;
  label: string;
  description: string;
}

export function useFeature(feature: FeatureKey): FeatureState {
  const { org } = useOrg();
  const rawPlan = org?.plan ?? "free";
  const plan = rawPlan as Plan;
  const spec = FEATURES[feature];
  // Demo sandboxes showcase the full product; never gate drafting / buyout /
  // import behind plan upsells during a live sales walkthrough.
  const enabled = Boolean(org?.isDemo) || hasFeature(plan, feature);
  return {
    enabled,
    currentPlan: rawPlan,
    normalizedPlan: plan,
    requiredPlan: spec.minPlan,
    feature,
    label: spec.label,
    description: spec.description,
  };
}
